import {Controller} from "@hotwired/stimulus"
import hljs from 'highlight.js/lib/core'
import html from 'highlight.js/lib/languages/xml'
import css from 'highlight.js/lib/languages/css'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
hljs.registerLanguage('html', html)
hljs.registerLanguage('css', css)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('json', json)

// Connects to data-controller="highlight"
export default class extends Controller {
  static targets = ["code"]

  codeTargetConnected(element) {
    const language = (element.classList[0].match(/language-(.+)/) || [null, "html"])[1]
    // Save anchor elements
    const anchors = [...element.querySelectorAll("a")]
    const placeholders = []

    anchors.forEach((a, i) => {
      const placeholder = `__LINK_${i}__`
      placeholders.push({ placeholder, node: a.cloneNode(true) })
      a.replaceWith(placeholder)
    })

    const raw = element.textContent
    element.innerHTML = hljs.highlight(raw, {language: language}).value

    // Restore anchors
    placeholders.forEach(({ placeholder, node }) => {
      element.innerHTML = element.innerHTML.replace(placeholder, node.outerHTML)
    })
  }
}
